module.exports = __webpack_public_path__ + "static/img/videotextEn.eeef830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiperpic/videotextEn.png
// module id = O0VY
// module chunks = 51